/**
 * Мост «веб-хост ↔ нативное приложение».
 *
 * Внутри мобильного WebView хост открывается с `?native=1`. В этом режиме
 * события виджета (оплата, переход, ошибка) уходят в React Native сообщением
 * `{ source: 'resto-host', ... }`, а команды приходят обратно с
 * `{ source: 'resto-native', ... }`.
 */

type NativeEnvelope = {
  source: 'resto-native';
  type: string;
  payload?: Record<string, unknown>;
};

const NATIVE_PARAM = 'native';

export function isNativeHost(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get(NATIVE_PARAM) === '1';
}

export function sendToNative(type: string, payload: Record<string, unknown> = {}): void {
  if (!isNativeHost()) return;
  const message = { source: 'resto-host', type, payload };
  // React Native WebView подставляет этот объект через injectedJavaScript.
  const bridge = (window as unknown as { ReactNativeWebView?: { postMessage(text: string): void } })
    .ReactNativeWebView;
  bridge?.postMessage(JSON.stringify(message));
}

export function onNativeMessage(handler: (message: NativeEnvelope) => void): () => void {
  if (typeof window === 'undefined') return () => undefined;
  const listener = (event: MessageEvent) => {
    const data = event.data;
    if (typeof data !== 'string') return;
    try {
      const parsed = JSON.parse(data) as NativeEnvelope;
      if (parsed && parsed.source === 'resto-native') handler(parsed);
    } catch {
      // Не наш формат — игнорируем.
    }
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
